<template>
<!--  수정 필요-->
  <div>
    <div class="banner-wrap">
      <div class="banner-image">
        <div class="inner-wrap">
          <div class="logo-area">
            <wavveonLogo/>
          </div>
          <div class="content-area">
            <wavveonImage/>
            <p class="banner-title">사업자용 서비스 웨이브온</p>
            <p class="banner-text">사업장의 유선, 무선 인터넷(Wi-Fi)에 접속한 고객들에게 <br />Wavve의 LIVE, VOD(다시보기)를 제공하는 서비스입니다.</p>
            <p class="banner-text">스마트폰, 태블릿, PC 등 N스크린으로 자유롭게 시청하세요!</p>
            <a @click.prevent="goExternalPage(`https://www.wavveon.com/Index_m.aspx?device=${device}`)" href="#">
              <span>웨이브온 더 알아보기</span>
              <moreButtonIcon/>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="voucher-pz-wrap">
      <h3 class="voucher-pz-hd">웨이브온 플러스 이용권</h3>

      <h4 class="voucher-pz-name">LIVE + VOD + Wavvie 영화 고화질 이용권</h4>
      <div class="voucher-pz-table-wrap">
        <table class="voucher-pz-table">
          <colgroup>
            <col width="33.3333%">
            <col width="33.3333%">
            <col width="33.3333%">
          </colgroup>
          <tbody>
          <tr>
            <th>
              <span>이용기기</span>
            </th>
            <th>
              <span>동시접속수</span>
            </th>
            <th>
              <span>월 이용료</span>
            </th>
          </tr>
          <tr>
            <th rowspan="3">
              <span class="pz-device">
                  <span>기본</span>
                  <span>무선 인터넷</span>
                  <span>추천상품</span>
              </span>
            </th>
            <td>
              <span>3회선</span>
            </td>
            <td>
              <span class="voucher-pz-price">41,700</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>5회선</span>
            </td>
            <td>
              <span class="voucher-pz-price">69,500</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>10회선</span>
            </td>
            <td>
              <span class="voucher-pz-price">139,000</span>
            </td>
          </tr>
          <tr>
            <th rowspan="3">
              <span class="pz-device">
                  <span>고속</span>
                  <span>무선 인터넷</span>
                  <span>추천상품</span>
              </span>
            </th>
            <td>
              <span>20회선</span>
            </td>
            <td>
              <span class="voucher-pz-price">278,000</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>30회선</span>
            </td>
            <td>
              <span class="voucher-pz-price">417,000</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>50회선</span>
            </td>
            <td>
              <span class="voucher-pz-price">695,000</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <h4 class="voucher-pz-name">LIVE + VOD + Wavvie 영화 초고화질 이용권</h4>
      <div class="voucher-pz-table-wrap">
        <table class="voucher-pz-table">
          <colgroup>
            <col width="33.3333%">
            <col width="33.3333%">
            <col width="33.3333%">
          </colgroup>
          <tbody>
          <tr>
            <th>
              <span>이용기기</span>
            </th>
            <th>
              <span>동시접속수</span>
            </th>
            <th>
              <span>월 이용료</span>
            </th>
          </tr>
          <tr>
            <th rowspan="3">
              <span class="pz-device">
                  <span>기본</span>
                  <span>무선 인터넷</span>
                  <span>추천상품</span>
              </span>
            </th>
            <td>
              <span>3회선</span>
            </td>
            <td>
              <span class="voucher-pz-price">50,700</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>5회선</span>
            </td>
            <td>
              <span class="voucher-pz-price">84,500</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>10회선</span>
            </td>
            <td>
              <span class="voucher-pz-price">169,000</span>
            </td>
          </tr>
          <tr>
            <th rowspan="3">
              <span class="pz-device">
                  <span>고속</span>
                  <span>무선 인터넷</span>
                  <span>추천상품</span>
              </span>
            </th>
            <td>
              <span>20회선</span>
            </td>
            <td>
              <span class="voucher-pz-price">338,000</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>30회선</span>
            </td>
            <td>
              <span class="voucher-pz-price">507,000</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>50회선</span>
            </td>
            <td>
              <span class="voucher-pz-price">845,000</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="voucher-pz-link">
      <a href="#" @click.prevent="goExternalPage('https://www.wavveon.com/Admin/Registration.aspx', '서비스 가입')"
         class="service">서비스 가입하기</a>
      <a href="#" @click.prevent="goExternalPage('https://www.wavveon.com/Admin/Index.aspx', '상품 구매')"
         class="product">상품 구매 바로가기</a>
    </div>

    <div class="voucher-pz-exclamation">
      <ul>
        <li>웨이브온 이용권은 사업자용 웨이브 서비스 상품으로 웨이브온에서만 시청가능한 전용상품입니다.</li>
        <li>웨이브온 이용권은 신용카드 결제만 가능합니다.</li>
        <li>해당 이용권은 자동결제 상품으로 매월 결제됩니다.</li>
        <li>
          <span>동시접속수 100대 이상의 경우, 별도 문의하세요.</span>
          <span>(제휴문의 1599-3709)</span>
        </li>
        <li>
          동시접속자는 동시에 웨이브서비스를 시청할 수 있는 최대인원을 의미합니다. 매장을 방문하시는 고객분들이 모두 동시 웨이브를 사용하지는 않기 때문에 매장 좌석수가 많더라도 동시에 시청할 것으로 예상되는 적정한 동시접속수를 감안하여 상품을 선택해주세요. (예시 : 좌석수 20개, 동시에 시청할 것으로 예상되는 최대 인원수 예상 5명의 경우 => 동시접속 5명 상품 구매)
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import wavveonLogo from '@/assets/svg/common/ic-logo-wavveon.svg'
import wavveonImage from '@/assets/svg/common/ic-package.svg'
import moreButtonIcon from '@/assets/svg/common/ic-next-s-g.svg'
import utils from '@/common/util/utils'
export default {
  name: 'PooqZoneVoucher',
  components: {
    wavveonLogo,
    wavveonImage,
    moreButtonIcon
  },
  data () {
    return {
      device: utils.cookies.getDevice()
    }
  },
  methods: {
    goExternalPage (url, title) {
      if (this.device === 'mobile') {
        location.href = url
      } else {
        location.href = `captvpooq://webview?url=${encodeURIComponent(url)}&external=n`
      }
    }
  }
}
</script>
